<div class="n-oldalfej">
  <div><h2>Ingatlan-bérbeadás</h2>
    <span class="n-alcim">{{ adat?.ugyfel?.nev }} · {{ adoszamos ? 'adószámos magánszemély' : 'magánszemély' }} · {{ ev }}</span></div>
  <div class="spacer"></div>
  <label class="ig-ev">Év <select [(ngModel)]="ev" (ngModelChange)="frissit()"><option *ngFor="let e of [ev + 1, ev, ev - 1, ev - 2]" [ngValue]="e">{{ e }}</option></select></label>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet.</div>

<ng-container *ngIf="adat">
  <div class="ig-fulek">
    <button type="button" [class.aktiv]="ful === 'osszesito'" (click)="ful = 'osszesito'"><ion-icon name="calculator-outline"></ion-icon>Összesítő és befizetések</button>
    <button type="button" [class.aktiv]="ful === 'tetelek'" (click)="ful = 'tetelek'"><ion-icon name="list-outline"></ion-icon>Bevételek és költségek</button>
    <button type="button" [class.aktiv]="ful === 'ingatlanok'" (click)="ful = 'ingatlanok'"><ion-icon name="home-outline"></ion-icon>Ingatlanok és bérletek</button>
  </div>

  <!-- ═══ ÖSSZESÍTŐ ═══ -->
  <ng-container *ngIf="ful === 'osszesito'">
    <p class="n-megj ig-sugo"><ion-icon name="information-circle-outline"></ion-icon>
      A bérbeadás jövedelme után <b>15% SZJA</b> jár; <b>szocho és járulék nincs</b> rajta (Szocho tv. 5. § (2) h)), és az anyák SZJA-mentessége
      sem terjed ki rá. Ha a bérlő <b>cég / kifizető</b>, ő vonja le az előleget és vallja be a 08-asban – itt csak látszik. Magánszemély
      bérlőtől kapott díj után az előleget <b>a bérbeadó fizeti negyedévente</b>.</p>

    <div class="ig-csempek">
      <div class="n-panel ig-csempe"><span>Bevétel ({{ ev }})</span><b>{{ o.bevetel | number:'1.0-0' }}</b></div>
      <div class="n-panel ig-csempe"><span>A kifizetők levonták</span><b>{{ o.levont | number:'1.0-0' }}</b></div>
      <div class="n-panel ig-csempe"><span>Saját előleg (befizetendő)</span><b>{{ o.sajat_befizetve | number:'1.0-0' }}</b></div>
      <div class="n-panel ig-csempe"><span>Szocho</span><b>0</b><small>mentes</small></div>
    </div>

    <h4 class="ig-cim">Negyedévente</h4>
    <div class="tabla-wrap"><table class="n-racs">
      <thead><tr><th>Negyedév</th><th class="num">Bevétel</th><th class="num">Ebből kifizetőtől</th><th class="num">Kifizető levonta</th>
        <th class="num">Saját előleg</th><th>Befizetés</th></tr></thead>
      <tbody>
        <tr *ngFor="let n of o.negyedevek">
          <td><b>{{ romai[n.negyedev - 1] }}</b></td>
          <td class="num">{{ n.bevetel | number:'1.0-0' }}</td>
          <td class="num">{{ n.kifizetotol | number:'1.0-0' }}</td>
          <td class="num">{{ n.levont | number:'1.0-0' }}</td>
          <td class="num">{{ n.sajat_eloleg | number:'1.0-0' }}</td>
          <td><ng-container *ngIf="n.befizetendo"><b>{{ n.befizetendo | number:'1.0-0' }} Ft</b> · {{ n.hatarido }}-ig</ng-container>
            <span class="halvany" *ngIf="!n.befizetendo && n.atvitel">nem kell (összesen {{ n.atvitel | number:'1.0-0' }} Ft ≤ 10 000) – továbbvisszük</span>
            <span class="halvany" *ngIf="!n.befizetendo && !n.atvitel">—</span></td>
        </tr>
      </tbody>
    </table></div>
    <p class="halvany ig-kicsi" *ngIf="o.sajat_befizetve">
      Hova: <b>{{ o.szamlak?.sajat?.nev }}</b>, {{ o.szamlak?.sajat?.szam }} ({{ o.szamlak?.sajat?.adonem }}-as adónem).</p>

    <h4 class="ig-cim">Éves elszámolás – {{ o.bevallas?.nyomtatvany }} SZJA-bevallás, {{ o.bevallas?.hatarido }}-ig</h4>
    <div class="tabla-wrap"><table class="n-racs">
      <thead><tr><th>Költségelszámolás</th><th class="num">Költség</th><th class="num">Jövedelem</th><th class="num">SZJA (15%)</th>
        <th class="num">Levont + befizetett előleg</th><th class="num">Különbözet</th></tr></thead>
      <tbody>
        <tr *ngFor="let v of [{ k: 'hanyad', n: '10% költséghányad', x: o.ev?.hanyad }, { k: 'teteles', n: 'Tételes (igazolt) költség', x: o.ev?.teteles }]"
            [class.ig-javasolt]="o.ev?.javasolt === v.k">
          <td>{{ v.n }} <span class="cimke zold" *ngIf="o.ev?.javasolt === v.k">kedvezőbb</span></td>
          <td class="num">{{ v.x?.koltseg | number:'1.0-0' }}</td>
          <td class="num">{{ v.x?.jovedelem | number:'1.0-0' }}</td>
          <td class="num">{{ v.x?.szja | number:'1.0-0' }}</td>
          <td class="num">{{ (o.levont + o.sajat_befizetve) | number:'1.0-0' }}</td>
          <td class="num"><b [class.piros]="v.x?.kulonbozet > 0" [class.zold]="v.x?.kulonbozet < 0">{{ v.x?.kulonbozet | number:'1.0-0' }}</b>
            <div class="halvany ig-kicsi">{{ v.x?.kulonbozet > 0 ? 'befizetendő' : (v.x?.kulonbozet < 0 ? 'visszajár' : '') }}</div></td>
        </tr>
      </tbody>
    </table></div>
    <p class="halvany ig-kicsi">A 10% költséghányadról az éves bevallásban át lehet térni a tételes költségre, fordítva nem (Szja tv. 47. § (3)).
      Ha a kifizetőnek adott nyilatkozatban több költséget jelöltél, mint amennyit végül elszámolsz, a különbözet 39%-a bírság.
      <ng-container *ngIf="adoszamos"> ÁFA-s bérbeadásnál a bevételt ÁFA nélkül számoljuk – ezt az Szja tv. 4. számú melléklete szerint ellenőrizd.</ng-container></p>
  </ng-container>

  <!-- ═══ BEVÉTELEK ÉS KÖLTSÉGEK ═══ -->
  <ng-container *ngIf="ful === 'tetelek'">
    <div class="ig-gombsor">
      <select [(ngModel)]="ho"><option *ngFor="let h of honapok" [ngValue]="h">{{ h }}. hó</option></select>
      <button type="button" class="ov-gomb" (click)="haviDijak()" [disabled]="!aktivBerletek.length"
              title="A hónapban élő bérletekből egy-egy bevételi sor a havi díjjal (ami már megvan, azt kihagyja)"><ion-icon name="repeat-outline"></ion-icon>A hónap bérleti díjai</button>
      <button type="button" class="ov-gomb" (click)="ujTetel('bevetel')"><ion-icon name="add-circle-outline"></ion-icon>Bevétel</button>
      <button type="button" class="ov-gomb" (click)="ujTetel('koltseg')"><ion-icon name="remove-circle-outline"></ion-icon>Költség</button>
    </div>

    <div class="n-panel ig-urlap" *ngIf="tetelSzerk">
      <div class="ig-racs">
        <label class="ig-m"><span>Dátum</span><input type="date" [(ngModel)]="tetelSzerk.datum"></label>
        <label class="ig-m ig-sz2" *ngIf="tetelSzerk.tipus === 'bevetel'"><span>Bérlet</span>
          <select [(ngModel)]="tetelSzerk.berlet_id"><option [ngValue]="null">– bérlet nélkül –</option>
            <option *ngFor="let b of aktivBerletek" [ngValue]="b.id">{{ b.berlo_nev }} · {{ ingatlanNev(b.ingatlan_id) }}</option></select></label>
        <label class="ig-m ig-sz2" *ngIf="tetelSzerk.tipus === 'koltseg'"><span>Ingatlan</span>
          <select [(ngModel)]="tetelSzerk.ingatlan_id"><option *ngFor="let i of adat.ingatlanok" [ngValue]="i.id">{{ i.megnevezes }}</option></select></label>
        <label class="ig-m ig-sz2"><span>Megnevezés</span><input [(ngModel)]="tetelSzerk.megnevezes" [placeholder]="tetelSzerk.tipus === 'koltseg' ? 'pl. felújítás, javítás, közös költség' : 'Bérleti díj'"></label>
        <label class="ig-m"><span>Összeg (nettó)</span><input type="number" [(ngModel)]="tetelSzerk.netto"></label>
        <label class="ig-m" *ngIf="adoszamos"><span>ÁFA</span><input type="number" [(ngModel)]="tetelSzerk.afa"></label>
      </div>
      <div class="nk-lab"><button type="button" class="ov-gomb" (click)="tetelSzerk = null">Mégse</button>
        <button type="button" class="ov-gomb fo" (click)="mentTetel()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
    </div>

    <h4 class="ig-cim">Bevételek</h4>
    <div class="tabla-wrap"><table class="n-racs">
      <thead><tr><th>Dátum</th><th>Bérlő / ingatlan</th><th class="num">Bevétel</th><th>Ki vonja le</th><th class="num">Költség (nyilatk.)</th><th class="num">Levont előleg</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let t of bevetelek">
          <td>{{ t.datum }}</td>
          <td>{{ berletNev(t.berlet_id) || t.megnevezes }}<div class="halvany ig-kicsi">{{ ingatlanNev(t.ingatlan_id) }}</div></td>
          <td class="num">{{ t.netto | number:'1.0-0' }}</td>
          <td><span class="cimke" [class.zold]="t.kifizeto_levont">{{ t.kifizeto_levont ? (t.kifizeto_nev || 'kifizető') : 'saját előleg' }}</span></td>
          <td class="num">{{ t.kifizeto_levont ? (t.koltseg_levonva | number:'1.0-0') : '' }}</td>
          <td class="num">{{ t.kifizeto_levont ? (t.szja_eloleg | number:'1.0-0') : '' }}</td>
          <td><button type="button" class="kv-mini" title="Törlés" (click)="torolTetel(t)"><ion-icon name="trash-outline"></ion-icon></button></td>
        </tr>
        <tr *ngIf="!bevetelek.length"><td colspan="7" class="halvany">Még nincs bevétel ebben az évben.</td></tr>
      </tbody>
    </table></div>

    <h4 class="ig-cim">Költségek <small class="halvany">(tételes elszámolásnál)</small></h4>
    <div class="tabla-wrap"><table class="n-racs">
      <thead><tr><th>Dátum</th><th>Megnevezés</th><th>Ingatlan</th><th class="num">Összeg</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let t of koltsegek">
          <td>{{ t.datum }}</td><td>{{ t.megnevezes }}</td><td>{{ ingatlanNev(t.ingatlan_id) }}</td><td class="num">{{ t.netto | number:'1.0-0' }}</td>
          <td><button type="button" class="kv-mini" title="Törlés" (click)="torolTetel(t)"><ion-icon name="trash-outline"></ion-icon></button></td>
        </tr>
        <tr *ngIf="!koltsegek.length"><td colspan="5" class="halvany">Nincs tételes költség – a 10% költséghányaddal számolunk.</td></tr>
      </tbody>
    </table></div>
  </ng-container>

  <!-- ═══ INGATLANOK ÉS BÉRLETEK ═══ -->
  <ng-container *ngIf="ful === 'ingatlanok'">
    <div class="ig-gombsor">
      <button type="button" class="ov-gomb" (click)="ujIngatlan()"><ion-icon name="add-outline"></ion-icon>Új ingatlan</button>
      <button type="button" class="ov-gomb" (click)="ujBerlet()" [disabled]="!adat.ingatlanok.length"><ion-icon name="key-outline"></ion-icon>Új bérlet</button>
    </div>

    <div class="n-panel ig-urlap" *ngIf="ingSzerk">
      <div class="ig-racs">
        <label class="ig-m ig-sz2"><span>Megnevezés *</span><input [(ngModel)]="ingSzerk.megnevezes" placeholder="pl. Váci lakás"></label>
        <label class="ig-m ig-sz2"><span>Cím</span><input [(ngModel)]="ingSzerk.cim"></label>
        <label class="ig-m"><span>Helyrajzi szám</span><input [(ngModel)]="ingSzerk.hrsz"></label>
        <label class="ig-m"><span>Tulajdoni hányad</span><input type="number" step="0.01" min="0" max="1" [(ngModel)]="ingSzerk.tulajdoni_hanyad"></label>
        <label class="ig-jel"><input type="checkbox" [(ngModel)]="ingSzerk.aktiv"> Aktív</label>
      </div>
      <div class="nk-lab"><button type="button" class="ov-gomb" (click)="ingSzerk = null">Mégse</button>
        <button type="button" class="ov-gomb fo" (click)="mentIngatlan()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
    </div>

    <div class="n-panel ig-urlap" *ngIf="berletSzerk">
      <div class="ig-racs">
        <label class="ig-m ig-sz2"><span>Ingatlan</span>
          <select [(ngModel)]="berletSzerk.ingatlan_id"><option *ngFor="let i of adat.ingatlanok" [ngValue]="i.id">{{ i.megnevezes }}</option></select></label>
        <label class="ig-m ig-sz2"><span>A bérlő a nyilvántartásban (kifizető cég)</span>
          <select [(ngModel)]="berletSzerk.berlo_ugyfel_id" (ngModelChange)="kifizetoValt($event)"><option [ngValue]="null">– nincs a nyilvántartásban –</option>
            <option *ngFor="let k of adat.kifizetok" [ngValue]="k.id">{{ k.nev }}{{ k.adoszam ? ' · ' + k.adoszam : '' }}</option></select></label>
        <label class="ig-m ig-sz2"><span>Bérlő neve *</span><input [(ngModel)]="berletSzerk.berlo_nev"></label>
        <label class="ig-m"><span>Bérlő adószáma</span><input [(ngModel)]="berletSzerk.berlo_adoszam"></label>
        <label class="ig-jel" title="Cég vagy egyéni vállalkozó: ő vonja le a 15% SZJA-előleget. Magánszemély bérlőnél a bérbeadó fizeti negyedévente.">
          <input type="checkbox" [(ngModel)]="berletSzerk.berlo_kifizeto"> A bérlő kifizető (levonja az előleget)</label>
        <label class="ig-m"><span>Havi bérleti díj (nettó)</span><input type="number" [(ngModel)]="berletSzerk.havi_dij"></label>
        <label class="ig-m" *ngIf="adoszamos"><span>ÁFA-kulcs (%)</span><input type="number" [(ngModel)]="berletSzerk.afa_kulcs" placeholder="mentes: üres"></label>
        <label class="ig-m"><span>Költség a nyilatkozatban</span>
          <select [(ngModel)]="berletSzerk.koltseg_mod"><option value="hanyad">10% költséghányad</option><option value="tetel">tételes – havi összeg</option></select></label>
        <label class="ig-m" *ngIf="berletSzerk.koltseg_mod === 'tetel'"><span>Nyilatkozott havi költség</span>
          <input type="number" [(ngModel)]="berletSzerk.koltseg_nyilatkozat"></label>
        <label class="ig-m"><span>Kezdete *</span><input type="date" [(ngModel)]="berletSzerk.kezdet"></label>
        <label class="ig-m"><span>Vége</span><input type="date" [(ngModel)]="berletSzerk.veg"></label>
      </div>
      <p class="ig-elonezet" *ngIf="berletEloleg as e">A kifizető havonta levon: (díj − {{ e.koltseg | number:'1.0-0' }} költség) × 15% = <b>{{ e.eloleg | number:'1.0-0' }} Ft</b>
        <span class="halvany">· a költség legfeljebb a díj 50%-a lehet; nyilatkozat nélkül 10%</span></p>
      <div class="nk-lab"><button type="button" class="ov-gomb" (click)="berletSzerk = null">Mégse</button>
        <button type="button" class="ov-gomb fo" (click)="mentBerlet()"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
    </div>

    <div class="ig-ingatlanok">
      <div class="n-panel ig-ingatlan" *ngFor="let i of adat.ingatlanok" [class.ig-inaktiv]="!i.aktiv">
        <div class="ig-ing-fej"><b>{{ i.megnevezes }}</b><span class="halvany">{{ i.cim }}{{ i.hrsz ? ' · hrsz. ' + i.hrsz : '' }}{{ +i.tulajdoni_hanyad < 1 ? ' · ' + (i.tulajdoni_hanyad * 100) + '%' : '' }}</span>
          <span class="spacer"></span>
          <button type="button" class="kv-mini" title="Bérlet ehhez" (click)="ujBerlet(i.id)"><ion-icon name="key-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Szerkesztés" (click)="szerkIngatlan(i)"><ion-icon name="create-outline"></ion-icon></button>
          <button type="button" class="kv-mini" title="Törlés" (click)="torolIngatlan(i)"><ion-icon name="trash-outline"></ion-icon></button></div>
        <div class="ig-berlet" *ngFor="let b of adat.berletek" [hidden]="b.ingatlan_id !== i.id">
          <span><b>{{ b.berlo_nev }}</b> <span class="cimke" [class.zold]="b.berlo_kifizeto">{{ b.berlo_kifizeto ? 'kifizető vonja le' : 'saját előleg' }}</span></span>
          <span>{{ b.havi_dij | number:'1.0-0' }} Ft/hó · {{ b.kezdet }}{{ b.veg ? ' – ' + b.veg : ' –' }}</span>
          <span class="halvany">{{ b.koltseg_mod === 'tetel' ? 'tételes: ' + (b.koltseg_nyilatkozat | number:'1.0-0') + ' Ft/hó' : '10% költséghányad' }}</span>
          <span class="ig-ber-muv">
            <button type="button" class="kv-mini" title="Szerkesztés" (click)="szerkBerlet(b)"><ion-icon name="create-outline"></ion-icon></button>
            <button type="button" class="kv-mini" title="Törlés" (click)="torolBerlet(b)"><ion-icon name="trash-outline"></ion-icon></button></span>
        </div>
      </div>
      <div class="ures" *ngIf="!adat.ingatlanok.length"><ion-icon name="home-outline"></ion-icon>Még nincs ingatlan – vedd fel az „Új ingatlan” gombbal.</div>
    </div>
  </ng-container>
</ng-container>
